import $ from 'jquery';

const scrollyTelling = (el) => {
    const $el = $(el);
    const id = `scrollytelling-${$el.index()}`;
    const $list = $el.children('ul').attr({
        'id': id,
        'aria-hidden': true,
    });
    const $items = $list.children('li');

    const $button = $el.children('button').attr({
        'aria-expanded': false,
        'aria-controls': id,
    });
    const buttonOpenText = $button.attr('data-open');
    const buttonCloseText = $button.attr('data-close');
    $button.text(buttonOpenText);

    $list.after('<div class="js-scrollytelling-crop-line" />');

    $items.first().addClass('js-state-scrollytelling-item-active');

    $items.each(function (index, item) {
        const $item = $(item);
        $item.attr('id', `scrollytelling-item-${index}`);
        const $verticalLine = $item.children('.js-scrollytelling-line').first();
        // Create the vertical-line element for the current item
        if (!$verticalLine.length) {
            $item.append('<div class="js-scrollytelling-line" />');
        }
    });

    // Used to fix css transition bug to make progress bar smoother
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Set up a scroll event listener on the window
    $items.each(function (index, item) {
        const $item = $(item);
        // const $heading = $item.children('h2').first();
        const $verticalLine = $item.children('.js-scrollytelling-line');

        // Check if another item is scrolled to initially and activate
        if (isScrolledIntoView($item, 100)) {
            if(index > 0) {
                const scrollProgress = getScrollProgresss($item);
                if(scrollProgress > 0) {
                    $item.addClass('js-state-scrollytelling-item-active');
                    $verticalLine.css('height', `calc(${scrollProgress}% + 2px)`);

                    $item.prevAll().removeClass('js-state-scrollytelling-item-active')
                        .children('.js-scrollytelling-line').css('height', 'calc(100% + 2px)');
                }
            }
        }

        let itemScrollProgress = 0;
        let scrollingState = 'outside';
        $(window).on('scroll', function (e) {
            e.stopPropagation();

            if (isScrolledIntoView($item, 0)) {
                const scrollProgress = getScrollProgresss($item, 200);
                if(scrollProgress !== itemScrollProgress) {
                    itemScrollProgress = scrollProgress;

                    let currentState = scrollingState;
                    if (scrollProgress >= 100) {
                        currentState = 'passed';
                    } else if (scrollProgress > 0) {
                        currentState = 'active';

                        if(isSafari) {
                            $verticalLine.css('height', `calc(${itemScrollProgress}% + 2px)`);
                            $verticalLine.stop(true).animate({'height': `${scrollProgress}%`}, 1);
                        } else {
                            $verticalLine.css('height', `calc(${scrollProgress}% + 2px)`);
                        }
                    } else {
                        currentState = 'outside';
                    }

                    if(currentState !== scrollingState) {
                        scrollingState = currentState;

                        if (currentState === 'passed') {
                            $verticalLine.css('height', 'calc(100% + 2px)');

                            // Don't remove active state when previous item is passed to prevent skipping states between items
                            if(!$item.hasClass('js-state-scrollytelling-item-passed')) {
                                $item.addClass('js-state-scrollytelling-item-passed');
                                $item.nextAll().removeClass('js-state-scrollytelling-item-active');
                            }
                        } else if (currentState === 'active') {
                            $items.not($item).removeClass('js-state-scrollytelling-item-active');
                            $item.nextAll().children('.js-scrollytelling-line').css('height', '0');

                            // Only needed once when class is added
                            if(!$item.hasClass('js-state-scrollytelling-item-active')) {
                                $item.addClass('js-state-scrollytelling-item-active');
                                $item.removeClass('js-state-scrollytelling-item-passed');
                            }
                        } else {
                            $verticalLine.css('height', '0');
                            $item.removeClass('js-state-scrollytelling-item-active');
                            $item.removeClass('js-state-scrollytelling-item-passed');
                        }
                    }
                }
            }
        });
    });

    const initialListHeight = $list.height();
    if(initialListHeight > 1000) {
        $list.css('height', '700px');
        $button.show().on('click', function() {
            const isExpanded = $button.attr('aria-expanded') === 'true';
            if (isExpanded) {
                $list.css('height', '700px');
                $button.text(buttonOpenText).attr('aria-expanded', 'false');
                const top = $list.offset().top - 100;
                $('html, body').animate({ scrollTop: top }, 500);
                $('.js-scrollytelling-crop-line').show();
            } else {
                $list.css('height', initialListHeight);
                $button.text(buttonCloseText).attr('aria-expanded', 'true');
                $('.js-scrollytelling-crop-line').hide();
            }
        });
    }

    function getScrollProgresss($elem, offset = 300) {
        const scrollTop = $(document).scrollTop();
        const itemTop = $elem.offset().top;
        const itemHeight = $elem.height();
        const progress = ((scrollTop - itemTop + offset) / itemHeight);
        return Math.min(Math.max(parseInt(100 * progress), 0), 100);
    }

    // Function to check if an element is scrolled into view with a given margin
    function isScrolledIntoView($elem, offset = 100) {
        const windowHeight = $(window).height();
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + windowHeight - offset;
        const elemTop = $elem.offset().top;
        const elemBottom = elemTop + $elem.height();

        return elemBottom >= docViewTop && elemTop <= docViewBottom;
    }
};

export default scrollyTelling;
